/*global FilePond, FilePondPluginFileValidateType, FilePondPluginFileValidateSize, myModal, analyticEventTracker, inputDirectionChange */

var compensation = {
    form: $('#compensation-form'),
    otherCategoryId: 28,
    fullCoverageCategoryId: 128,
    relaxPackageCategoryId: 158,
    fullCoverageCheckboxes: [],
    fullCoverageCheckboxesText: [],
    pond: [],
    isValidationEnabled: false,
    pickedClaimCategory: 0,
    previewType: '',
    previewSubType: '',
    init: function() {
        compensation.action();
    },

    subCategoryAnalyticsClick: function(postData, element, isError = false) {
        let dataAttributes = {};

        if (element instanceof jQuery) {
            dataAttributes = (typeof element.data() !== 'undefined' ? element.data() : false);
        } else {
            dataAttributes = Array.from(element.attributes).map(attr => ({ name: attr.name, value: attr.value }));
            dataAttributes = dataAttributes.filter(attr => attr.name === 'aria-describedby');
        }

        if (dataAttributes) {
            const attributes = analyticEventTracker.collectAttributes(dataAttributes, isError);

            if (Object.keys(attributes).length > 0) {
                postData['attributes'] = attributes;
                postData['attributes']['attributeReservation'] = $('#reservation-number').val();
            }
        }

        analyticEventTracker.trackEvent(postData);
    },

    serializeRemove: function(thisArray, thisName) {
        return thisArray.filter( function( item ) {
            return item.name !== thisName;
        });
    },
    action: function() {

        $('#bankCountry').chosen({
            inherit_select_classes: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%'
        }).on('blur', function() {
            $(this).trigger('chosen:updated');
        });

        $('input[type=radio][name=claim_category]').change(function() {
            $('.claim-category-dropdown').addClass('hide');
            let that = $(this);
            let value = parseInt(that.val());
            let selected = '';
            const element = that.attr('data-active');

            compensation.closeClaimForm();
            compensation.updatePreviewType('');
            compensation.updatePreviewSubType('');

            if (compensation.pond.length > 0) {
                compensation.resetFiles();
            }

            if (value === compensation.otherCategoryId || value === compensation.fullCoverageCategoryId || value === compensation.relaxPackageCategoryId) {
                compensation.pickedClaimCategory = value;
            } else {
                let select = $('#select-'+value);
                if (select.data('child') !== '') {
                    compensation.pickedClaimCategory = select.data('child');
                }
            }

            $('#dropdown-' + value).removeClass('hide');

            if (element === 'true') {
                compensation.openClaimForm();
            }

            if (value === compensation.fullCoverageCategoryId) {
                compensation.renderFullCoverageFiles();
                compensation.validateForm();
            } else if (value === compensation.relaxPackageCategoryId) {
                compensation.renderRelaxPackageFiles();
                compensation.validateForm();
            } else if (compensation.pickedClaimCategory !== 0) {
                compensation.renderFiles(compensation.pickedClaimCategory);
                compensation.validateForm();
            }

            compensation.updatePreviewType($('label[for="' + this.id + '"]').text());
            compensation.updatePreviewSubType($('#select-' + value).find('option:selected').text());

            if (value === compensation.fullCoverageCategoryId || value === compensation.relaxPackageCategoryId) {
                selected = $('#dropdown-' + value).find('.claim-checkbox').first();
            } else {
                selected = $('#dropdown-' + value).find('.claim-category-select option:selected');
            }
            compensation.updateDescription(selected.data('description'));
        });

        $('select[name=claimCategory]').on('change', function() {
            compensation.pickedClaimCategory = parseInt($(this).val());
        }).on('focus', function() {
            const that = $(this);
            const dataAttributes = that.data();
            analyticEventTracker.sendInstantEvent(that.data('eventName'), dataAttributes);
        });

        $('.claim-category-select').change(function() {
            let that = $(this);
            const value = parseInt(that.val());
            that.data('child', parseInt($(this).val()));
            const selected = that.find('option:selected');
            const dataAttributes = selected.data();
            const descriptionText = selected.data('description');
            const parentIndex = that.data('parent');
            const parentRadio = $('#category-' + parentIndex);

            compensation.updatePreviewSubType($(this).find('option:selected').text());

            if (compensation.pond.length > 0) {
                compensation.resetFiles();
            }

            if (value === 0) {
                parentRadio.attr('data-active', false);
                compensation.closeClaimForm();
            } else {
                parentRadio.attr('data-active', true);
                compensation.updateDescription(descriptionText);
                compensation.openClaimForm();
                if (compensation.isValidationEnabled === false) {
                    compensation.initialRender();
                }
                compensation.renderFiles(value);
                compensation.validateForm();
                analyticEventTracker.sendInstantEvent(selected.data('eventName'), dataAttributes);
            }
        });

        $('.claim-checkbox').change(function() {
            const that = $(this);
            const value = parseInt(that.val());
            const descriptionText = that.data('description');
            const parentIndex = that.data('parent');
            const parentRadio = $('#category-' + parentIndex);
            const text = $('label[for="' + this.id + '"]').text();
            const index = compensation.fullCoverageCheckboxes.indexOf(value);

            compensation.updateDescription(descriptionText);

            if (index === -1) {
                compensation.fullCoverageCheckboxes.push(value);
                compensation.fullCoverageCheckboxesText.push(text);
            } else {
                compensation.fullCoverageCheckboxes.splice(index, 1);
                compensation.fullCoverageCheckboxesText.splice(index, 1);
            }

            if (compensation.fullCoverageCheckboxes.length >= 1) {
                parentRadio.attr('data-active', true);
                compensation.updatePreviewSubType(compensation.fullCoverageCheckboxesText.join(', '));
                compensation.openClaimForm();
                if (compensation.isValidationEnabled === false) {
                    compensation.initialRender();
                }

                if (parentIndex === compensation.relaxPackageCategoryId) {
                    compensation.renderRelaxPackageFiles();
                } else {
                    compensation.renderFullCoverageFiles();
                }

                compensation.validateForm();
            } else {
                parentRadio.attr('data-active', false);
                compensation.closeClaimForm();
            }
        });


        FilePond.registerPlugin(FilePondPluginFileValidateType);
        FilePond.registerPlugin(FilePondPluginFileValidateSize);

        $.validator.addMethod('fullname', function(value) {
            return /^[a-zA-Z ,.'-]+ [a-zA-Z ,.'-]+$/.test(value);
        });

        $.validator.addMethod('iban', function() {
            let isSuccess = false;
            $.ajax({
                url: _d.url.reservation.compensation.validateIban,
                data: {
                    iban: $('#iban').val(),
                    countryCode: $('#bankCountry').val()
                },
                type: 'POST',
                async: false,
                success: function(response) {
                    isSuccess = response;
                }
            });
            return isSuccess;
        });

        $.validator.addMethod('swift', function() {
            let isSuccess = false;
            $.ajax({
                url: _d.url.reservation.compensation.validateSwift,
                data: {
                    swift: $('#bic').val()
                },
                type: 'POST',
                async: false,
                success: function(response) {
                    isSuccess = response;
                }
            });
            return isSuccess;
        });

        $.validator.addMethod('onlyLatin', function(val) {
            const latinMatch = /^[a-zA-Z\.\'\-\s]+$/;
            return latinMatch.test(val.trim()) !== false;
        });

        $('#compensation-type').val('bank');

        $('#amount').keypress(function(e) {
            const charCode = (e.which) ? e.which : e.keyCode;
            const value = $(this).val();

            if (value.indexOf('.') !== -1) {
                if (charCode < 48 || charCode > 57) {
                    return false;
                }
                return value.indexOf('.') <= 4 && value.length <= value.indexOf('.') + 2;
            }
            if (value.indexOf(',') !== -1) {
                if (charCode < 48 || charCode > 57) {
                    return false;
                }
                return value.indexOf(',') <= 4 && value.length <= value.indexOf(',') + 2;
            }
            if (value.length === 5 && charCode !== 44 && charCode !== 46) {
                return false;
            }
            if (charCode === 44) {
                return true;
            }
            if (charCode === 46) {
                return true;
            }
            if (charCode !== 46 && (charCode < 48 || charCode > 57)) {
                return false;
            }

            return !((value.indexOf(',') === -1 || value.indexOf('.') === -1) && value.length > 3);
        });

        const englishAlphabetAndWhiteSpace = /^[-@./#&+\w\s]*$/;
        const bankRegex = /[,. \w\s\/#&@+-]/;
        $('#fullname').on('keypress', function(event) {
            const key = String.fromCharCode(event.which);
            if (englishAlphabetAndWhiteSpace.test(key)) {
                const allowedKeyCodes = [0, 8, 32, 121, 122];
                if (!(event.keyCode >= 65 && event.keyCode <= 120) && allowedKeyCodes.indexOf(event.keyCode) === -1) {
                    event.preventDefault();
                    return false;
                }
                return true;
            }

            return false;
        });

        $('#bank').on('keypress', function(event) {
            const key = String.fromCharCode(event.which);
            return bankRegex.test(key);
        });

        $('#address').on('keypress', function(event) {
            const key = String.fromCharCode(event.which);
            return bankRegex.test(key);
        });

        $('#payment-card').on('click', function() {
            $('#compensation-type').val('bank');
        });

        $('#payment-paypal').on('click', function() {
            $('#compensation-type').val('paypal');
        });

        $('.back-to-step-one').on('click', function(e) {
            e.preventDefault();
            $('#step-2').hide();
            $('#step-1').show();
        });

        $('#cancel-btn').on('click', function(e) {
            e.preventDefault();
            document.location.href = $(this).data('link');
        });

        $('#go-to-step-two').on('click', function() {
            let reviewNames = [];
            let labelTexts = [];
            let dataIds = [];

            $('.claim-file').not('.d-none').each(function() {
                const that = $(this);

                reviewNames.push(that.data('name'));
                labelTexts.push(that.data('label'));
                dataIds.push(that.data('id'));
            });
            compensation.showUploadedFiles(reviewNames, labelTexts, dataIds);
        });

        $('#go-to-step-three').on('click', function(e) {
            e.preventDefault();
            const formData = $(this).closest('form').serializeArray();
            let updatedForm = compensation.serializeRemove(formData, 'claim_category');
            updatedForm = $.param(updatedForm);
            $(this).prop('disabled', true).addClass('loading');
            updatedForm += '&claim_category=' + compensation.pickedClaimCategory + '&file_upload=true';

            analyticEventTracker.sendInstantEvent('File_Claim_Submit_Click', $(this).data());

            //SUBMIT DATA TO BACK-END
            $.ajax({
                url: _d.url.reservation.compensation.createClaim
                    .replace('number', $('#reservation-number').val())
                    .replace('email', $('#reservation-email').val()),
                type: 'POST',
                data: updatedForm,
                success: function(response) {
                    //DEPENDING ON RESULT SHOW NEEDED MODAL
                    $(window).scrollTop(0);
                    myModal.staticModal((response === 'Success' ? 'compensationGoodModal' : 'compensationBadModal'), {noHeader: true});
                    $(this).prop('disabled', false).removeClass('loading');
                },
                error: function() {
                    $(window).scrollTop(0);
                    myModal.staticModal('compensationBadModal', {noHeader: true});
                    $(this).removeClass('loading');
                }
            });
        });

        inputDirectionChange.onChangeAction('input,textarea');
    },
    validationRuleMessages: {
        bank_address: {
            required: _d.t.fieldRequired
        },
        bank_name: {
            required: _d.t.fieldRequired
        },
        swift: {
            required: _d.t.fieldRequired,
            swift: _d.t.fieldNotValid
        },
        amount: {
            required: _d.t.fieldRequired
        },
        fullname: {
            required: _d.t.fieldRequired,
            fullname: _d.t.enterFullName,
            onlyLatin: _d.t.fullNameOnlyLatin
        },
        reason: {
            required: _d.t.fieldRequired,
            minlength: _d.t.atLeast10
        },
        iban: {
            required: _d.t.fieldRequired,
            iban: _d.t.fieldNotValid
        },
        paypal_email: {
            required: _d.t.fieldRequired,
            email: _d.t.invalidEmail
        },
        paypal_fullname: {
            required: _d.t.fieldRequired
        },
        bankCountry: {
            required: _d.t.fieldRequired
        },
        recipient_address: {
            required: _d.t.fieldRequired
        }
    },
    validationRules: {
        bank_address: {
            required: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        bank_name: {
            required: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        fullname: {
            required: true,
            onlyLatin: true,
            fullname: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        recipient_address: {
            maxlength: 100,
            required: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        bank_additional: {
            maxlength: 100
        },
        reason: {
            required: true,
            minlength: 10,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        amount: {
            required: true,
            maxlength: 7
        },
        iban: {
            required: true,
            iban: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        paypal_email: {
            required: true,
            email: true,
            normalizer: function(value) {
                return $.trim(value);
            }
        },
        bankCountry: {
            required: true
        },
        swift: {
            required: true,
            swift: true
        }
    },
    validateForm: function() {
        if (this.validator) {
            this.validator.destroy();
        }

        this.validator = $('body').find('#compensation-form').validate({
            onkeyup: false,
            focusInvalid: true,
            errorClass: 'error error-message show filepond-error',
            errorElement: 'div',
            rules: compensation.validationRules,
            messages: compensation.validationRuleMessages,
            onfocusout: function(element) {
                this.element(element);

                if ((element.classList.contains('validate-input') || element.classList.contains('input-field')) && element.classList.contains('error')) {
                    const postData = {
                        eventName: 'File_Claim_FormFields_Error'
                    };

                    compensation.subCategoryAnalyticsClick(postData, element, true);
                }
            },
            invalidHandler: function(event, validator) {
                const errors = validator.numberOfInvalids();
                if (errors) {
                    validator.errorList.forEach(function(error) {
                        if (error.element.type === 'file') {

                            const dataAttributes = Array.from(error.element.parentNode.parentNode.parentNode.attributes)
                                .filter(attr => attr.name === 'data-name' || attr.name === 'data-label')
                                .reduce((acc, attr) => {
                                    if (attr.name === 'data-name') {
                                        acc.attributeName = attr.value;
                                    } else if (attr.name === 'data-label') {
                                        acc.attributeLabel = attr.value;
                                    }

                                    acc.attributeReservation = $('#reservation-number').val();

                                    return acc;
                                }, {});

                            analyticEventTracker.sendInstantEvent('File_Claim_Attachment_Error', dataAttributes);
                        }
                    });
                }

                event.preventDefault();
            },
            submitHandler: function() {
                const compensationType = $('#compensation-type').val();
                const emailBlock = $('#email-block');

                //Set data for preview page
                $('#preview-reason').text($('#reason').val());
                $('#preview-amount').text($('#amount').val());
                $('#preview-currency').text($('#currency').val());
                $('.preview-type').addClass('hidden');

                if (compensationType === 'bank') {
                    $('#preview-type-bank').removeClass('hidden');
                    emailBlock.addClass('hidden');
                    let formBlocks = ['fullname', 'bank', 'address', 'iban', 'bic', 'recipientAddress', 'bankAdditional', 'bankCountry'];
                    for (let i = 0; i < formBlocks.length; i++) {
                        $('#' + formBlocks[i] + '-block').removeClass('hidden');
                        let inputValue = $('#' + formBlocks[i]).val();

                        if (formBlocks[i] === 'bankCountry') {
                            inputValue = $('#bankCountry  option:selected').text();
                        }

                        if (inputValue === '') {
                            $('#preview-' + formBlocks[i]).text('-');
                        } else {
                            $('#preview-' + formBlocks[i]).text(inputValue);
                        }
                    }
                } else if (compensationType === 'paypal') {
                    $('#preview-type-paypal').removeClass('hidden');
                    let formBlocks = ['bank', 'address', 'iban', 'bic', 'recipientAddress', 'bankAdditional', 'bankCountry'];
                    for (let j = 0; j < formBlocks.length; j++) {
                        $('#' + formBlocks[j] + '-block').addClass('hidden');
                    }
                    emailBlock.removeClass('hidden');
                    $('#preview-email').text($('#paypal-email').val());
                    $('#preview-fullname').text($('#paypal-fullname').val());
                }

                $('#step-1').hide();
                $('#step-2').show();
                $(window).scrollTop(0);
            }
        });
    },
    renderFiles: function(CategoryTypeId) {
        $('.claim-file').addClass('d-none').each(function() {
            if ($(this).data('category') === CategoryTypeId) {
                $(this).removeClass('d-none');
            }
        });
    },
    renderOtherFile: function() {
        $('.claim-file').addClass('d-none').each(function() {
            if ($(this).data('category') === 121) {
                $(this).removeClass('d-none');
            }
        });
    },
    renderFullCoverageFiles: function() {
        $('.claim-file').addClass('d-none').each(function() {
            if ($(this).data('category') === 129) {
                $(this).removeClass('d-none');
            }
        });
    },
    renderRelaxPackageFiles: function() {
        $('.claim-file').addClass('d-none').each(function() {
            if ($(this).data('category') === 159) {
                $(this).removeClass('d-none');
            }
        });
    },
    filepondRules: {
        allowFileTypeValidation: true,
        acceptedFileTypes: ['image/png', 'image/jpeg', 'application/pdf'],
        labelInvalidField: _d.t.labelInvalidField,
        labelFileWaitingForSize: _d.t.labelFileWaitingForSize,
        labelFileSizeNotAvailable: _d.t.labelFileSizeNotAvailable,
        labelFileLoading: _d.t.labelFileLoading,
        labelFileLoadError: _d.t.labelFileLoadError,
        labelFileProcessing: _d.t.labelFileProcessing,
        labelFileProcessingComplete: _d.t.labelFileProcessingComplete,
        labelFileProcessingAborted: _d.t.labelFileProcessingAborted,
        labelFileProcessingError: _d.t.labelFileProcessingError,
        labelFileProcessingRevertError: _d.t.labelFileProcessingRevertError,
        labelFileRemoveError: _d.t.labelFileRemoveError,
        labelTapToCancel: _d.t.labelTapToCancel,
        labelTapToRetry: _d.t.labelTapToRetry,
        labelTapToUndo: _d.t.labelTapToUndo,
        labelButtonRemoveItem: _d.t.labelButtonRemoveItem,
        labelButtonAbortItemLoad: _d.t.labelButtonAbortItemLoad,
        labelButtonRetryItemLoad: _d.t.labelButtonRetryItemLoad,
        labelButtonAbortItemProcessing: _d.t.labelButtonAbortItemProcessing,
        labelButtonUndoItemProcessing: _d.t.labelButtonUndoItemProcessing,
        labelButtonRetryItemProcessing: _d.t.labelButtonRetryItemProcessing,
        labelButtonProcessItem: _d.t.labelButtonProcessItem,
        fileValidateTypeLabelExpectedTypes: _d.t.fileValidateTypeLabelExpectedTypes,
        labelFileTypeNotAllowed: _d.t.fileOfInvalidType,
        labelIdle: _d.t.dragAndDrop,
        labelMaxFileSize: _d.t.labelMaxFileSize,
        labelMaxFileSizeExceeded: _d.t.fileIsTooLarge,
        labelMaxTotalFileSize: _d.t.labelMaxTotalFileSize,
        allowFileSizeValidation: true,
        maxFileSize: '8MB',
        maxTotalFileSize: '80MB',
        allowMultiple: true,
        server: {
            url: _d.url.reservation.compensation.fileUpload
            .replace('number', $('#reservation-number').val())
            .replace('email', $('#reservation-email').val()),
            process: {
                method: 'POST',
                withCredentials: false,
                headers: {},
                timeout: 7000,
                onload: function(res) {
                    const obj = JSON.parse(res);
                    return obj.tmp_filename;
                },
                onerror: null,
                ondata: null
            },
            revert: {
                method: 'DELETE',
                withCredentials: false,
                headers: {},
                timeout: 7000
            }
        }
    },
    resetFiles: function() {
        for (let i = 0; i < compensation.pond.length; i++) {
            let pond_ids = [];
            if (compensation.pond[i].getFiles().length !== 0) {  // "pond" is an object, created by FilePond.create
                compensation.pond[i].getFiles().forEach(function(file) {
                    pond_ids.push(file.id);
                });
            }
            compensation.pond[i].removeFiles(pond_ids);
        }
    },
    initialRender: function() {
        $('.my-pond').each(function(index) {
            const that = $(this);
            const inputName = that.attr('name');
            const isRequired = that.data('required');
            const maxCount = that.data('count');

            if (maxCount !== '') {
                compensation.filepondRules.maxFiles = parseInt(maxCount);
                compensation.filepondRules.maxParallelUploads = parseInt(maxCount);
            }

            //data attribute
            if (isRequired) {
                compensation.validationRuleMessages[inputName] = { required: _d.t.pleaseAddAFile };
                compensation.validationRules[inputName] = { required: true, extension: 'pdf|jpg|jpeg|png'};
            } else {
                compensation.validationRules[inputName] = { extension: 'pdf|jpg|jpeg|png'};
            }

            compensation.pond[index] = FilePond.create(this, compensation.filepondRules);
            compensation.pond[index].on('error', () => {
                compensation.pond[index].removeFiles();
            });
        });
        compensation.isValidationEnabled = true;
    },
    closeClaimForm: function() {
        $('#hidden-form').addClass('hide');
        $('#go-to-step-two').prop('disabled', true);
    },
    openClaimForm: function() {
        $('#hidden-form').removeClass('hide');
        $('#go-to-step-two').prop('disabled', false);
    },
    updateDescription: function(descriptionText) {
        $('#claim-description').empty().append(descriptionText);
    },
    updatePreviewType: function(updateText) {
        compensation.previewType = updateText;
        $('#preview-type').text(compensation.previewType);
    },
    updatePreviewSubType: function(updateText) {
        compensation.previewSubType = updateText;
        if (updateText !== '') {
            $('#preview-sub-type').html('<div class="mt-10">' + compensation.previewSubType + '</div>');
        } else {
            $('#preview-sub-type').text(compensation.previewSubType);
        }
    },
    showUploadedFiles: function(reviewNames, labelTexts, dataIds) {
        $('#review-docs').html('');
        let i = 0;
        if (reviewNames.length >= 1) {
            reviewNames.forEach((element) => {
                let needToDisplayBlock = true;
                $('#' + dataIds[i] + '-' + element + ' .filepond--file').each(function(index, el) {
                    if (needToDisplayBlock) {
                        $('#review-docs').append('<div class="dc-ui flex mt-24 mb-16 align-items-center">\n' +
                          '                            <div class="mr-16">\n' +
                          '                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                          '                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.68512 2.31994C4.68512 1.92231 5.00746 1.59998 5.40508 1.59998H18.4325C18.8301 1.59998 19.1524 1.92231 19.1524 2.31994C19.1524 2.71757 18.8301 3.03991 18.4325 3.03991H6.12505V28.96H25.875V10.4236C25.875 10.026 26.1973 9.70368 26.595 9.70368C26.9926 9.70368 27.3149 10.026 27.3149 10.4236V29.68C27.3149 30.0776 26.9926 30.4 26.595 30.4H5.40508C5.00746 30.4 4.68512 30.0776 4.68512 29.68V2.31994Z" fill="#333333"/>\n' +
                          '                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8703 3.76917V9.98375H25.13L18.8703 3.76917ZM17.4304 2.60001C17.4304 2.04236 17.8834 1.59998 18.4325 1.59998C18.6225 1.59998 18.8048 1.67512 18.9397 1.80901L27.1022 9.91271C27.2384 10.0479 27.3149 10.2318 27.3149 10.4236C27.3149 10.9813 26.8619 11.4237 26.3129 11.4237H18.4325C17.8834 11.4237 17.4304 10.9813 17.4304 10.4236V2.60001Z" fill="#333333"/>\n' +
                          '                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33632 20.1923C9.33632 19.7947 9.65866 19.4723 10.0563 19.4723H22.3092C22.7068 19.4723 23.0291 19.7947 23.0291 20.1923C23.0291 20.5899 22.7068 20.9123 22.3092 20.9123H10.0563C9.65866 20.9123 9.33632 20.5899 9.33632 20.1923Z" fill="#333333"/>\n' +
                          '                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33632 15.6898C9.33632 15.2922 9.65866 14.9699 10.0563 14.9699H22.3092C22.7068 14.9699 23.0291 15.2922 23.0291 15.6898C23.0291 16.0875 22.7068 16.4098 22.3092 16.4098H10.0563C9.65866 16.4098 9.33632 16.0875 9.33632 15.6898Z" fill="#333333"/>\n' +
                          '                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33632 24.6947C9.33632 24.2971 9.65866 23.9748 10.0563 23.9748H22.3092C22.7068 23.9748 23.0291 24.2971 23.0291 24.6947C23.0291 25.0924 22.7068 25.4147 22.3092 25.4147H10.0563C9.65866 25.4147 9.33632 25.0924 9.33632 24.6947Z" fill="#333333"/>\n' +
                          '                                </svg>\n' +
                          '                            </div>\n' +
                          '                            <label class="text-16 mb-0">' + labelTexts[i] + '</label>\n' +
                          '                        </div>\n' +
                          '                        <div class="w-100 pl-48" id="block-' + element + '">\n' +
                          '                        </div>');

                        $('#block-' + element).html('');
                        needToDisplayBlock = false;
                    }
                    const $el = $(el);
                    const filename = $el.find('.filepond--file-info-main').text();
                    if (filename) { $('#block-' + element).append("<div class='text-14 text-gray-500 p-16 file-holder mb-12'>" + filename + '</div>'); }
                });
                i++;
            });
        }
    }
};
